<template>
  <div class="c-container ui-h-full">
    <div class="c-row c-center ui-h-full">
      <div class="c-col-full sm:c-col-4 md:c-col-8 lg:c-col-6">
        <div class="ui-relative c-bg-white ui-rounded-md">
          <!-- Header -->
          <div class="c-row ui-p-6">
            <div class="c-col-full c-d-flex c-justify-between c-items-center">
              <h3 class="c-text-h3">
                Incluir e-mail
              </h3>
            </div>
          </div>

          <!-- Content -->
          <div class="c-row ui-pb-6 ui-pr-6 ui-pl-6">
            <div class="c-col-full">
              <!-- Loading State -->
              <div
                v-if="loading"
                class="ui-mb-6"
              >
                <p class="c-text-b1 c-text-center">
                  Adicionando e-mail...
                </p>
                <p class="c-text-b2 ui-mt-2 ui-text-gray-600 c-text-center">
                  Aguarde enquanto processamos sua solicitação.
                </p>
              </div>

              <!-- Normal Form State -->
              <form
                v-else
                @submit.prevent="handleSubmit"
              >
                <div class="ui-mb-6">
                  <p-input
                    v-model="email"
                    label="E-mail"
                    type="email"
                    name="email"
                    :error-message="emailError"
                    placeholder="Digite o e-mail"
                    data-cy="addEmailInput"
                    required
                  />
                </div>

                <!-- Buttons -->
                <div class="c-d-flex c-justify-end ui-space-x-3">
                  <c-button
                    outline
                    @click="$modal.hide()"
                    data-cy="cancelAddEmailButton"
                  >
                    Cancelar
                  </c-button>
                  <c-button
                    @click="handleSubmit"
                    data-cy="confirmAddEmailButton"
                  >
                    Adicionar
                  </c-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CButton } from '@estrategiahq/coruja-web-ui';
import PInput from '@/components/p-input';
import { communicationEmailAlreadyExistsError } from '@/utils/errors';

export default {
  name: 'AddEmailModal',
  components: {
    CButton,
    PInput,
  },
  data() {
    return {
      email: '',
      emailError: '',
      loading: false,
    };
  },
  methods: {
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email) {
        this.emailError = 'E-mail é obrigatório';
        return false;
      }
      if (!emailRegex.test(this.email)) {
        this.emailError = 'E-mail inválido';
        return false;
      }
      this.emailError = '';
      return true;
    },

    async handleSubmit() {
      if (!this.validateEmail()) {
        return;
      }

      this.loading = true;

      try {
        await this.$services.accounts.createCommunicationEmail(this.email);

        this.$emit('email-added');

        setTimeout(() => {
          this.$modal.hide();
        }, 500);

      } catch (error) {
        let toastType = 'error';
        if (error === communicationEmailAlreadyExistsError) {
          toastType = 'warning';
        }

        this.$toast.show({
          type: toastType,
          text: error.message,
          timeout: 3000,
        });

        this.$modal.hide();
      }
    },
  },
};
</script>
